import React from 'react';
import { HStack, Text, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { BsRobot } from 'react-icons/bs';
import webCore from '@happylife-a/web-core';

const MotionIcon = motion.div;
const MotionText = motion.div;

export default function Header({ isLoading }) {
  const { t } = webCore.contexts.useTranslation();
  const robotVariants = {
    idle: {
      rotate: 0,
      scale: 1,
      transition: { duration: 0.3 },
    },
    loading: {
      rotate: [0, 10, -10, 0],
      scale: [1, 1.1, 1],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
  };

  return (
    <VStack spacing={4} align="center">
      <HStack spacing={3}>
        <MotionIcon
          style={{
            color: 'white',
            fontSize: '24px',
          }}
          variants={robotVariants}
          animate={isLoading ? 'loading' : 'idle'}
        >
          <BsRobot />
        </MotionIcon>
        <MotionText
          style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: 'white',
            textAlign: 'center',
          }}
          animate={isLoading ? { scale: [1, 1.05, 1] } : { scale: 1 }}
          transition={{ duration: 2, repeat: isLoading ? Infinity : 0 }}
        >
          {t('AI Content Generator')}
        </MotionText>
      </HStack>

      {/* Instructions */}
      <Text color="white" textAlign="center" fontSize="md" maxW="400px">
        {t('Upload a product image and let AI generate title and description in 3 languages')}
      </Text>
    </VStack>
  );
}
